import { useAsyncOperation } from "@core/hooks/use-async-operation";
import { useI18n } from "@core/i18n/i18n";
import { legalContentManager } from "@core/service-container";
import styled from "@emotion/styled";
import { NetworkError } from "@ui/components/common/error";
import { LoadingContainer } from "@ui/components/common/loading-container";
import { RoutesPath } from "@ui/navigation/routes";
import { DocumentViewer } from "@ui/pages/legal-content/components/document-viewer";
import { stack } from "@ui/style/layout";
import { useObservable } from "micro-observables";
import React, { useCallback, useEffect } from "react";

export const TermsOfUsePage = (): JSX.Element => {
	const { format, locale } = useI18n();
	const retrieveTermsOfUse = useCallback(() => legalContentManager.retrieveTermsOfUse(locale), [locale]);
	const [operation, isLoading, isError] = useAsyncOperation(retrieveTermsOfUse, {});
	const termsOfUse = useObservable(legalContentManager.termsOfUse);
	let fallbackContent: JSX.Element | null = null;

	if (isLoading) {
		fallbackContent = <LoadingContainer />;
	} else if (isError) {
		fallbackContent = <NetworkError onRefresh={operation} />;
	}

	useEffect(() => {
		operation();
	}, [operation]);

	return (
		<Container>
			{termsOfUse ? (
				<DocumentViewer
					title={format("legalContent.termsOfUse.title")}
					content={termsOfUse.content}
					headerLink={{ label: format("legalContent.termsOfUse.switchLabel"), to: RoutesPath.PrivacyNotice }}
				/>
			) : (
				fallbackContent
			)}
		</Container>
	);
};

const Container = styled.div`
	${stack(undefined, "center", "stretch")};
	flex-grow: 1;
`;
